import React from 'react';

export function MCQQuestion({ question, selectedAnswer, onAnswerSelect,index }) {

  const handleValueChange = (e) => {
    onAnswerSelect(question._id, e.target.value);
  };
  
  return (
    <div className="mb-4">
          <p className="font-semibold">{`${index + 1}. ${question.questionText}`}</p>
          {question.options.map((optionObj, idx) => (
        <label key={idx} className="block mt-2">
          <input
            type="radio"
            name={`question-${question._id}`}
            value={optionObj.option}
            checked={selectedAnswer === optionObj.option}
            onChange={handleValueChange}
            className="mr-2"
          />
          {optionObj.option}
        </label>
      ))}

    </div>
  );
}